import { createStore } from 'vuex'
const config = require('@/config')
import router from "../router";
import axios from "axios";
import i18n from "@/i18n";
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')

import { modifiers } from "@/store/modifiers";
import { statistics } from "@/store/statistics";
import { notifications } from "@/store/notifications";
import { maps } from "@/store/maps";
import { deploy } from "@/store/deploy";
import { modules } from "@/store/modules";
function loadImage(url) {
  return new Promise(function(resolve, reject) {
    let img = new Image();
    img.onload = function() {
      return resolve(url);
    }
    img.onerror = function() {
      return reject(url);
    }
    img.src = url;
  });
}

export default createStore({
  modules: {
    modifiers,
    statistics,
    notifications,
    maps,
    deploy,
    modules
  },
  state: {
    userPool: [],
    authDetails: '',
    userData: '',
    cognitoUser: null,
    tokens: {
      accessToken: '',
      idToken: '',
      refreshToken: '',
    },
    // username: '',
    errCode: '',
    // attributes: [],
    authenticated: false,
    company: {},
    restaurants: [],
    restaurantItem: {},
    restaurantMenu: {},
    restaurantMenuItem: {},
    restaurantOrders: {},
    restaurantOrdersPages: [],
    restaurantOrderItem: {},
    restaurantMenuSort: 'default',
    loading: {
      restaurants: true,
      restaurantItem: false,
      categories: false,
      menu: true,
      orders: true,
    },
    orderIsUpdating: false,
    orderPulling: false,
    orderPageSize: 10,
    orderPageEnd: false,
    productMeasure: [i18n.global.t('productMeasure.g'), i18n.global.t('productMeasure.ml')],
  },
  getters: {
    AUTHENTICATED(state) { return state.authenticated },
    ERRCODE(state) { return state.errCode },
    COMPANY(state) { return state.company },
    RESTAURANTS(state) { return state.restaurants },
    RESTAURANT(state) { return state.restaurantItem },
    RESTAURANTMENU(state) { return state.restaurantMenu },
    RESTAURANT_MENU_ITEM(state) { return state.restaurantMenuItem },
    RESTAURANTMENUSORT(state) { return state.restaurantMenuSort },
    RESTAURANTORDERS(state) { return state.restaurantOrders.orders },
    RESTAURANT_ORDERS_PAGES(state) { return state.restaurantOrdersPages },
    RESTAURANT_ORDER_ITEM(state) { return state.restaurantOrderItem},
    LOADING(state) { return state.loading},
    ORDER_IS_UPDATING(state) {return state.orderIsUpdating},
    ORDER_PULLING(state) {return state.orderPulling},
    ORDER_PAGE_SIZE(state) {return state.orderPageSize},
    ORDER_PAGE_END(state) {return state.orderPageEnd},
    PRODUCT_MEASURE(state) {return state.productMeasure},
  },
  mutations: {
    // TODO: Registration
    signIn (state) {
      state.authenticated = true
    },
    signOut (state) {
      state.cognitoUser.signOut()
      state.sessionToken = null
      state.authenticated = false
      state.username = ''
      state.userPool = []
    },
    setUserPool (state) {
      state.userPool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData)
    },
    setTokens (state, payload) {
      state.tokens.accessToken = payload.getAccessToken().getJwtToken()
      state.tokens.idToken = payload.getIdToken().getJwtToken()
      state.tokens.refreshToken = payload.getRefreshToken().getToken()
    },
    setCognitoUser (state, payload) {
      state.cognitoUser = payload
    },
    setCognitoDetails (state, authData) {
      state.authDetails = new AmazonCognitoIdentity.AuthenticationDetails(authData)
      state.userData = { Username: authData.Username, Pool: state.userPool }
      console.log(state.userData)
      state.cognitoUser = new AmazonCognitoIdentity.CognitoUser(state.userData)
    },
    setError (state, payload) {
      state.errCode = payload
    },
    clearError (state) {
      state.errCode = ''
    },
    //TODO: Restaurants
    setCompanyId (state, payload) {
      state.company = payload
    },
    setRestaurants (state, payload) {
      state.restaurants = payload
    },
    setRestaurantItem (state, payload) {
      state.restaurantItem = payload
    },
    clearRestaurantItem (state) {
      state.restaurantItem = {};
    },
    setRestaurantMenu (state, payload) {
      state.restaurantMenu = payload
    },
    clearRestaurantMenuItem (state) {
      state.restaurantMenuItem = {}
    },
    setRestaurantMenuItem(state, payload) {
      state.restaurantMenuItem = payload
    },
    addSpinnerToProduct(state, payload) {
      //payload = {index, type}
      state.restaurantMenu[payload.index].loading = payload.type
    },
    setImgForRestaurantMenuItem(state, payload) {
      state.restaurantMenuItem.src = `${config.servImgUrl}${state.company.id}/${payload.restId}/${payload.prodId}/images/thumbnail.jpg`
      state.restaurantMenuItem.src_main = `${config.servImgUrl}${state.company.id}/${payload.restId}/${payload.prodId}/images/main.jpg`
    },
    setRestaurantMenuItemOld (state, prodId) {
      state.restaurantMenuItem = state.restaurantMenu.find((elem)=> {
        return elem.id === prodId
      })
    },
    async newAddImageToRestaurantMenu(state, restId) {
        if(state.company.id === undefined) {
          await this.dispatch('getCompanyInfo')
        }
      state.restaurantMenu.forEach(function (item) {
        item.src = `${config.servImgUrl}${state.company.id}/${restId}/${item.id}/images/thumbnail.jpg`
        item.src_main = `${config.servImgUrl}${state.company.id}/${restId}/${item.id}/images/main.jpg`
      })
    },
    setRestaurantMenuSort (state, payload) {
      state.restaurantMenuSort = payload
    },
    setImagesForRestaurants(state, payload) {
      payload.forEach((item, index) => {
        let url = `${config.servImgUrl}${state.company.company_id}/${item.id}/images/main.jpg`
        state.restaurants[index].src = url
      })
    },
    changeLoadingRestaurantItem(state, payload) {
      state.loading.restaurantItem = payload
    },
    //TODO: Restaurant Orders
    setRestaurantOrders (state, payload) {
      state.restaurantOrders = payload
    },
    setRestaurantOrderItem (state, payload) {
      state.restaurantOrderItem = payload
    },
    changeLoadingOrders (state, payload) {
      state.loading.orders = payload
    },
    setOrderIsUpdating(state, payload) {
      state.orderIsUpdating = payload
    },
    addSpinnerToOrder(state, orderId) {
      let orders = state.restaurantOrders.orders
      for(let key in orders) {
        if (orders[key].id === orderId) {
          orders[key].loading = true
          break;
        }
      }
    },
    setOrderPulling(state, payload) {
      state.orderPulling = payload
    },
    //TODO: Restaurants Orders Pages
    setOrderPageSize (state, payload) {
      state.orderPageSize = payload
    },
    setNewOrdersPage (state) {
      state.restaurantOrdersPages.push(state.restaurantOrders.orders)
    },
    clearRestaurantOrdersPages (state) {
      state.restaurantOrdersPages = []
      state.orderPageEnd = false
    },
    setEndOrdersPage (state, payload) {
      state.orderPageEnd = payload ? false : true;
    },
  },
  actions: {
    // TODO: Registration
    signIn({state, commit, dispath}, authData) {
      commit('clearError')
      commit('setUserPool')
      commit('setCognitoDetails', authData)
      state.cognitoUser.authenticateUser(state.authDetails, {
        onSuccess: (result) => {
          commit('setTokens', result)
          commit('signIn')
          router.push('/')
        },
        onFailure: (err) => {
          console.log('sign in failure')
          commit('setError', JSON.stringify(err.code))
        }
      })
    },
    async tryAutoSignIn ({ state, commit }) {
      // console.log('starting tryAutoSignIn')
      commit('setUserPool')
      const updateSession = new Promise((resolve, reject) => {
        let cognitoUser = state.userPool.getCurrentUser()
        if (cognitoUser != null) {
          commit('setCognitoUser', cognitoUser)
          state.cognitoUser.getSession(async function (err, session) {
            if (err) {
              await console.error(JSON.stringify(err))
              await state.dispatch('signOut')
              reject()
            } else {
              await commit('setTokens', session)
              await commit('signIn')
              resolve()
            }
          })
        }
      })
      await updateSession
      //console.log('ended tryAutoSignIn')
    },
    signOut ({ commit }) {
      commit('signOut')
      router.push('/signin')
    },
    async checkIdToken({state, dispatch}) {
      const idTokenTime = state.cognitoUser.signInUserSession?.idToken.payload.exp
      // console.log(idTokenTime)
      if (idTokenTime) {
        // console.log('Token Expired: ', new Date(idTokenTime * 1000))
        const tokenExpired = Date.now() >= idTokenTime * 1000
        // console.log('Время токена истекло: ' + tokenExpired)
        if (tokenExpired) {
          await this.dispatch('tryAutoSignIn')
            .then(() => {
              return true
            })
            .catch(() => {
              // console.log ('Ошибка переавторизации')
              return false
            })
        } else {
          return true
        }
      } else {
        dispatch('signOut')
      }
    },
    //TODO: Restaurants
    async getCompanyInfo({state, commit, dispatch}) {
      await dispatch('checkIdToken')
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.get(`${config.servUrl}admin/companies`, axiosHeader)
          .then(response => {
            commit('setCompanyId', response.data)
          })
          .catch(error => {
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error);
          })
    },
    async getRestaurants({ state, commit, dispatch }) {
      await dispatch('checkIdToken')
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      if (!state.company.company_id) { //если нет информации о комании, то загружаем её
        await this.dispatch('getCompanyInfo')
      }
      await axios.get(`${config.servUrl}admin/restaurants`, axiosHeader)
          .then(response => {
            response.data.sort((r1,r2) => // сортируем в алфавитном порядке
              (r1.title.toLowerCase() > r2.title.toLowerCase()) ? 1 : -1
            )
            commit('setRestaurants', response.data)
            commit('setImagesForRestaurants', response.data) //записываем картинки для ресторана
            return true
          })
          .catch(error => {
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error);
          })
          .finally(() => (state.loading.restaurants = false))
    },
    async getRestaurantItem({ state, commit, dispatch }, restId) {
      await dispatch('checkIdToken')
      commit('changeLoadingRestaurantItem', true)
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.get(`${config.servUrl}admin/restaurants/` + restId, axiosHeader)
          .then(response => {
            commit('setRestaurantItem', response.data)
            this.dispatch('getImageForRestaurant', restId)
            commit('changeLoadingRestaurantItem', false)
            return true
          })
          .catch(error => {
            dispatch('addNewNotice', {text: error, error: true})
            commit('changeLoadingRestaurantItem', false)
            console.log(error);
          })
    },
    async getRestaurantMenu({ state, commit, dispatch }, restId) {
      await dispatch('checkIdToken')
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      axios.get(`${config.servUrl}admin/menu-items/` + restId, axiosHeader)
          .then(response => {
            commit('setRestaurantMenu', response.data)
            // this.dispatch('uploadImgToRestaurantMenu', restId) // временно отключил старую подгрузку картинок
            commit('newAddImageToRestaurantMenu', restId)    // новая загрузка картинок, просто подставляется ссылка в объект.
            return true
          })
          .catch(error => {
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error);
          })
          .finally(() => (state.loading.menu = false))
    },
    async getRestaurantMenuItem({state, commit, dispatch}, payload) {
      //payload = {restId, prodId}
      await dispatch('checkIdToken')
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.get(`${config.servUrl}admin/menu-items/${payload.restId}/${payload.prodId}`, axiosHeader)
          .then(response => {
            commit('clearRestaurantMenuItem')
            commit('setRestaurantMenuItem', response.data) //записывает меню в state
            commit('setImgForRestaurantMenuItem', payload) //записывает картинки к продукту
          })
          .catch(error => {
            console.log(error);
            dispatch('addNewNotice', {text: error, error: true})
          })
    },
    async addRestaurantCategory({ state, commit, dispatch }, payload) {
      await dispatch('checkIdToken')
      state.loading.categories = true
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      axios.put(`${config.servUrl}admin/restaurants/` + payload.restId, payload.data, axiosHeader)
        .then(response => {
          this.dispatch('getRestaurantItem', payload.restId)
          dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.restaurantCategoriesUpdated')})
        })
        .catch(error => {
          console.log(error);
          dispatch('addNewNotice', {text: error, error: true})
        })
        .finally(() => (state.loading.categories = false))
    },
    getImageForRestaurant({ state }, restId) { //подставнока картинки конкретному ресторану
      if(!state.company.company_id) {
        this.dispatch('getCompanyInfo')
      }
      let url = `${config.servImgUrl}${state.company.company_id}/${restId}/images/main.jpg`
      state.restaurantItem.image_src = url
      let logo = `${config.servImgUrl}${state.company.company_id}/${restId}/logo/images/thumbnail.jpg`
      state.restaurantItem.logo_src = logo
    },
    //TODO: Restaurant Orders
    async getRestaurantOrders({state, commit, dispatch}, payload) {
      //payload = {restId, start_key}
      await dispatch('checkIdToken')
      let params
      if (payload.start_key) {
        params = `page_size=${state.orderPageSize}&start_key=${payload.start_key}&short_info=true`
      } else {
        params = `page_size=${state.orderPageSize}&short_info=true`
      }
      commit('changeLoadingOrders', true)
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.get(`${config.servUrl}admin/orders/restaurant/${payload.restId}?${params}`, axiosHeader)
          .then(response => {
            commit('setRestaurantOrders', response.data)
            commit('setEndOrdersPage', response.data.last_evaluated_key) //проверка на последнюю страницу заказов.
            commit('setNewOrdersPage')
            commit('changeLoadingOrders', false)
          })
          .catch(error => {
            console.log(error);
            commit('changeLoadingOrders', false)
            dispatch('addNewNotice', {text: error, error: true})
          })
    },
    async getRestaurantOrderItem({state, commit, dispatch}, payload) { //повесить его на все изменения в заказе
      await dispatch('checkIdToken')
      commit('setOrderIsUpdating', true)
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      axios.get(`${config.servUrl}admin/orders/${payload.restId}/${payload.orderId}`, axiosHeader)
          .then(response => {
            commit('setRestaurantOrderItem', response.data)
            commit('setOrderIsUpdating', false)
          })
          .catch(error => {
            console.log(error);
            commit('setOrderIsUpdating', false)
            dispatch('addNewNotice', {text: error, error: true})
          })
          .finally(() => (state.loading.orders = false))
    },
    async addOrderStatus({state, commit, dispatch}, payload) {
      await dispatch('checkIdToken')
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.put(`${config.servUrl}admin/orders/${payload.restId}/${payload.orderId}/status`, payload.requestBody, axiosHeader)
          .then(response => {
            this.dispatch('getRestaurantOrderItem', payload) //обновляем конкретный заказ
            dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.orderStatusUpdated')})
            return response.data
          })
          .catch(error => {
            console.log(error);
            dispatch('addNewNotice', {text: error, error: true})
          })
    },
    async changeMenuItemInOrder({state, commit, dispatch}, payload) {
      await dispatch('checkIdToken')
      commit('setOrderIsUpdating', true)
      let idToken = state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      axios.put(`${config.servUrl}admin/orders/${payload.restId}/${payload.orderId}`, payload.requestBody, axiosHeader)
          .then(response => {
            this.dispatch('getRestaurantOrderItem', {restId: payload.restId, orderId: payload.orderId})
            dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.orderUpdated')})
            return response.data
          })
          .catch(error => {
            console.log(error);
            dispatch('addNewNotice', {text: error, error: true})
            commit('setOrderIsUpdating', false)
          })
    }
  },

});
